export const GET_LIST = "GET_LIST";
export const GET_LIST_SUCCESS = "GET_LIST_SUCCESS";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const CUSTOM_OFFER_ACCEPT ="CUSTOM_OFFER_ACCEPT";
export const GENERATE_TOKEN = "GENERATE_TOKEN";
export const GENERATE_TOKEN_SUCCESS = "GENERATE_TOKEN_SUCCESS";
export const ZOOM_MEETING = "ZOOM_MEETING";
export const ZOOM_MEETING_SUCCESS = "ZOOM_MEETING_SUCCESS";